import React, { useRef } from 'react';

export default function Header() {
  const clearRef = useRef(null);
  const closeRef = useRef(null);

  const handleMinimize = () => {
    console.log('Minimize clicked');
    // Add minimize functionality here (e.g., collapse widget, hide chat, etc.)
  };

  const handleClear = () => {
    console.log('Clear conversation clicked');
    if (window.Pernoex && typeof window.Pernoex.clearMessages === 'function') {
      window.Pernoex.clearMessages();
    } else {
      console.warn('Pernoex.clearMessages is not available');
    }
  };

  const handleClose = () => {
    window.location.href = 'https://developer.flutterwave.com/';
  };

  return (
    <header className="header">
      <div className="header-left">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
          <ellipse cx="9.8995" cy="10.8284" rx="5" ry="9" transform="rotate(-45 9.8995 10.8284)" fill="#2A3362" />
          <ellipse cx="12.728" cy="10.8995" rx="5" ry="9" transform="rotate(45 12.728 10.8995)" fill="#2A3362" />
        </svg>
        <span className="header-title">Flutterwave AI Assistant</span>
      </div>
      <div className="header-right">
        <button type="button" className="icon-btn" aria-label="Clear conversation" ref={clearRef} onClick={handleClear} id="btn-clear">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 14 18" fill="currentColor">
            <path
              d="M11 6V16H3V6H11ZM9.5 0H4.5L3.5 1H0V3H14V1H10.5L9.5 0ZM13 4H1V16C1 17.1 1.9 18 3 18H11C12.1 18 13 17.1 13 16V4Z" />
          </svg>
        </button>
        <button type="button" className="icon-btn" aria-label="Close" ref={closeRef} onClick={handleClose} id="btn-close">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="currentColor">
            <path
              d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" />
          </svg>
        </button>
      </div>
    </header>
  );
}
